import React, { useState, useEffect } from 'react';
import axiosInstance from '../../axiosInstance';

const HomeAdmin = () => {
  const [homeContent, setHomeContent] = useState({ description: '', links: [] });

  useEffect(() => {
    fetchHomeContent();
  }, []);

  const fetchHomeContent = async () => {
    try {
      const response = await axiosInstance.get('/home');
      const { description, links } = response.data;
      setHomeContent({
        description: description || '',
        links: Array.isArray(links) ? links : (links ? links.split(',') : [])
      });
    } catch (error) {
      console.error('Error fetching home content:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHomeContent((prevContent) => ({
      ...prevContent,
      [name]: name === 'links' ? value.split(',') : value
    }));
  };

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    try {
        const response = await axiosInstance.put('/home', {
          description: homeContent.description,
          links: homeContent.links
        });
        console.log(response.data);
        fetchHomeContent();
      } catch (error) {
        console.error('Error updating home content:', error.response?.data || error.message);
        // Optionally, display an error message to the user
      }
  };

  return (
    <div className='max-w-7xl mx-auto px-4'>
      <h1 className="text-4xl font-semibold mb-3 text-gray-900 dark:text-[rgb(211,219,236)]">Home</h1>
      <form onSubmit={handleSubmit} className='w-[60%] max-sm:w-full'>
        <div>
          <label className='dark:text-white text-[#111318]'>Description:</label>
          <textarea 
            type="text" 
            name="description" 
            value={homeContent.description} 
            onChange={handleChange} 
            className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'
          />
        </div>
        <div>
          <label className='dark:text-white text-[#111318]'>Links:</label>
          <input 
            type="text" 
            name="links" 
            value={homeContent.links.join(',')} 
            onChange={handleChange} 
            className='block bg-transparent border-[1px] border-gray-600 rounded-md w-full p-2 my-2 text-gray-900 dark:text-[rgb(211,219,236)]'
          />
        </div>
        <button 
          type="submit" 
          className='bg-blue-200 dark:bg-yellow-600 px-6 py-3 text-gray-900 dark:text-[rgb(211,219,236)] rounded-md hover:dark:bg-yellow-700 hover:bg-blue-400'
        >
          Update Home
        </button>
      </form>
    </div>
  );
};

export default HomeAdmin;
